import styled from 'styled-components';

// Modal Header Styles
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #ffffff;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    padding: 24px 1rem;
  }
`;

export const ModalHeaderTitle = styled.h2`
  font-family: Roboto;
  font-size: 1.25rem;
  font-weight: 700;
  color: #171c24;
  margin: 0;
  flex: 1;
  text-align: center;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

// Modal Body Styles
export const ModalBody = styled.div`
  padding: 0px 0.75rem ${props => props.paddingBottom ?? '20px'} 0.75rem;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff !important;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media screen and (max-width: 768px) {
    padding: 0px 1rem
      calc(${props => props.paddingBottom ?? '100px'} + env(safe-area-inset-bottom, 0px)) 1rem;
  }
`;

export const ServiceSelectionSubtitle = styled.p`
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 500;
  color: #171c24;
  margin: 0 0 20px 0;
  text-align: left;
`;

// Service Card Styles
export const ServiceCard = styled.div`
  display: flex;
  padding: 4px 8px 4px 4px;
  border-radius: 4px;
  margin-bottom: 12px;
  border: 1.2px solid #f3f3f3;
  background-color: ${props => (props.selected ? '#E8F5E8' : '#F8F8F8')};
  cursor: pointer;
  position: relative;
  align-items: stretch;
  min-height: 80px;

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    border-radius: 8px;
    min-height: 80px;
  }
`;

export const ServiceCardIcon = styled.div`
  margin-right: 15px;
  display: flex;
  align-items: center;

  img {
    width: 77px;
    height: 65px;
  }

  @media screen and (max-width: 768px) {
    margin-right: 20px;

    img {
      width: 77px;
      height: 65px;
    }
  }
`;

export const ServiceCardContent = styled.div`
  flex: 1;
`;

export const ServiceCardTitle = styled.h3`
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 600;
  color: #333333;
  margin-top: 4px;

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ServiceCardPrice = styled.p`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 300;
  color: #333333;
  margin-top: 5px;

  @media screen and (max-width: 768px) {
    font-size: 1rem;
    margin-top: 8px;
  }
`;

export const ServiceCardActionAdd = styled.div`
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: ${props => (props.selected ? '30px' : '35.78px')};
  height: ${props => (props.selected ? '30px' : '29.75px')};
  border-radius: 8px;
  background-color: #00a81f;
  color: white;
  font-weight: bold;
  box-shadow: 0px 6px 20px 0px #1a843f4d;
  ${props => props.selected && 'box-shadow: 0px 4px 16px 0px rgba(24, 94, 136, 0.15);'};

  @media screen and (max-width: 768px) {
    width: ${props => (props.selected ? '40px' : '45px')};
    height: ${props => (props.selected ? '40px' : '45px')};
    border-radius: 12px;
    font-size: 18px;
  }
`;

export const ServiceCardActionRemove = styled.div`
  border: 1px solid #d2d4d7;
  align-self: center;
  width: 20px;
  height: 20px;
  background-color: transparent;
  color: #757778;
  font-size: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: 30px;
    height: 30px;
    font-size: 24px;
    border-radius: 8px;
  }
`;

export const LearnMoreLink = styled.a`
  font-family: Rubik;
  font-size: 0.75rem;
  font-weight: 500;
  color: #333333;
  text-decoration: underline;
  cursor: pointer;
`;

// Selected Services Styles
export const SelectedServicesSection = styled.div`
  margin-top: 30px;
`;

export const SelectedServicesTitle = styled.h3`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  color: #171c24;
  margin: 0 0 14px 0;
`;

export const SelectedServiceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 4px;
`;

export const SelectedServiceName = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 500;
  color: #757778;
`;

export const DottedPriceServiceItem = styled.div`
  display: flex;
  flex: 1;
  height: 18px;
  border-bottom: 1px dotted #757778;
`;

export const SelectedServicePrice = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 500;
  color: #757778;
`;

// Modal Footer Styles
export const ModalFooter = styled.div`
  padding: 0 20px 20px 20px;

  ${props =>
    props.center
      ? `
  justify-content: center;
  display: flex;
  `
      : ''}

  @media screen and (max-width: 768px) {
    padding: 0 1rem calc(1rem + env(safe-area-inset-bottom, 0px)) 1rem;
    flex-shrink: 0;
    background-color: #ffffff;
  }
`;

export const TotalSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const TotalLabel = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 500;
  color: #171c24;
  margin-right: 4px;
`;

export const TotalPrice = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 700;
  color: #171c24;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 6px;
  background-color: ${props => (props.disabled ? 'rgba(34, 170, 82, 0.3)' : '#00A81F')};
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-bottom: 10px;
  margin-top: ${props => props.marginTop ?? '16px'};
  width: ${props => props.width ?? '100%'};

  @media screen and (max-width: 768px) {
    height: 52px;
    font-size: 18px;
    margin-bottom: 15px;
  }
`;

export const SecondaryLink = styled.a`
  display: block;
  text-align: center;
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 400;
  color: #2274a5;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 1rem;
`;

// Portal Modal Styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 0;
    align-items: stretch;
  }
`;

export const ModalContainer = styled.div`
  background-color: #ffffff !important;
  border-radius: 4px;
  width: ${props => {
    if (props.isMobile) return '100%';
    if (props.isWarrantyModal) return '800px';
    return '500px';
  }};
  max-width: calc(100vw - 40px);
  max-height: 90vh;
  overflow-y: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100vw !important;
    height: 100% !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 0;
  }
`;
